"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimSearchQuery = trimSearchQuery;
exports.parseQueryString = parseQueryString;
exports.getQueryStringParameter = getQueryStringParameter;
exports.getIdTokenQuery = getIdTokenQuery;
exports.toArray = toArray;
const lib_1 = require("../types/lib.js");
const sonar_ts_constants_1 = require("@sonar-software/sonar-ts-constants");
const qs_1 = require("qs");
const castValues = {
    false: false,
    null: null,
    true: true,
    undefined: undefined
};
function trimSearchQuery(query = '') {
    return query === null || query === void 0 ? void 0 : query.substring(query.indexOf('?') + 1);
}
function parseQueryString(query) {
    const trimmedQuery = trimSearchQuery(query);
    return (0, qs_1.parse)(trimmedQuery, {
        decoder: (str, decoder, charset, type) => {
            if (type === 'value' && (0, lib_1.isNumeric)(str) && (str.length === 1 || !str.toString().startsWith('0'))) {
                return Number(str);
            }
            if (type === 'value' && str in castValues) {
                return castValues[str];
            }
            return decoder(str, decoder, charset);
        }
    });
}
function getQueryStringParameter(query, key) {
    const trimmedQuery = trimSearchQuery(query);
    const parameters = (0, qs_1.parse)(trimmedQuery);
    return parameters[key];
}
function getIdTokenQuery(query) {
    return getQueryStringParameter(query.slice(1), sonar_ts_constants_1.QUERY.OIDC_TOKEN);
}
function toArray(val) {
    if (val) {
        return typeof val === 'string' ? [val] : val;
    }
    return [];
}
//# sourceMappingURL=lib.js.map